import { useForm } from '@mantine/form';

import { selectPersonId } from '@/store/user-process/user-selectors.ts';

import { TDateRange } from '@/shared/types/app.types';
import { BookingType } from '@/shared/types/bookingObjects.types';

import { useAppSelector } from '@/hooks';

type TRadarForm = {
	booking_object_id?: number | null;
	client_id: number | undefined;
	pass_id?: number | null;
	object_kind?: BookingType;
	kind: 'fast' | 'default' | 'periodicAny' | 'periodicAll';
	time_before_stop: string | null;
	period_start?: string | Date | null;
	period_end?: string | Date | null;
	only_notify: boolean | null;
	date: TDateRange;
};

type TRadarFormOptions = {
	isPassRequired: boolean;
};

export const useRadarForm = ({ isPassRequired }: TRadarFormOptions) => {
	const personId = useAppSelector(selectPersonId);

	const form = useForm<TRadarForm>({
		initialValues: {
			kind: 'default',
			only_notify: false,
			time_before_stop: '',
			client_id: personId,
			date: [null, null],
			booking_object_id: null,
		},
		validate: {
			client_id: (value) => (!value ? 'Invalid client_id' : null),
			booking_object_id: (value) => (!value ? 'Invalid booking_object_id' : null),
			pass_id: (value) => (isPassRequired && !value ? 'Invalid pass_id' : null),
		},
	});

	return form;
};
